import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const EditWithoutBackgroundIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.9097 8.23747L16.62 9.52709L13.9729 6.87997L15.2625 5.59034C15.3983 5.45459 15.5651 5.38672 15.7631 5.38672C15.9611 5.38672 16.1279 5.45459 16.2637 5.59034L17.9097 7.23631C18.0454 7.37206 18.1133 7.53892 18.1133 7.73689C18.1133 7.93486 18.0454 8.10172 17.9097 8.23747ZM5.38672 15.4662L13.2093 7.64356L15.8564 10.2907L8.03384 18.1133H5.38672V15.4662Z'
                fill='currentColor'
            />
        </>
    ),
})

EditWithoutBackgroundIcon.displayName = 'EditWithoutBackgroundIcon'
